import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgComponent } from 'icon';
import { PCProduct } from 'product';
import { TranslatePipe } from 'translate';

@Component({
  selector: 'lib-table-mobile',
  standalone: true,
  imports: [SvgComponent, TranslatePipe],
  templateUrl: './table-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableMobileComponent {
  @Input() product: PCProduct;
}
